export const PAGE_VIEW = 'page_viewed'
export const CLICK = 'clicked'
export const PRODUCT_IMPRESSION = 'product_impression'
export const REVIEW_IMPRESSION = 'review_impression'
export const REVIEW_BLOCK_IMPRESSION = 'review_block_impression'
export const PURCHASE_PRODUCT = 'purchase_product'
export const PURCHASE_ORDER = 'purchase_order'
export const ADD_TO_CART = 'add_to_cart'
export const PRODUCT_CLICK = 'product_clicked'
export const FORM_SUBMIT = 'info_submitted'
export const PROMOTION_CLICK = 'promotion_clicked'
export const PROMOTION_IMPRESSION = 'promotion_impression'
export const MODAL = 'modal_viewed'
export const PRODUCT = 'product'
export const CHECKOUT_PAGE_VIEW = 'checkout_page_viewed'
export const PROMPT_NOTIFICATION_IMPRESSION = 'promptNotificationImpression'
